// Miroir front du registre backend des catégories de notifications
// (backend/svp/notifications.py — source de vérité).
//
// ⚠️ L'ÉLIGIBILITÉ N'EST PLUS ICI (30.07.2026) : « qui reçoit quoi » est devenu
// de la donnée, éditée par le boss dans Configuration → Notifications, et
// arrive résolue par le serveur dans `accessInfo.notifCategories` (cf.
// api/access). Ce fichier ne garde que ce qui est
// STRUCTUREL et sert au rendu : le libellé et le cycle de vie.
//
// `cycle` : "traite" (actionnable partagée, bouton Terminer) ou "auto_expire"
// (éphémère : pas de Terminer, disparaît des actifs à l'échéance).
export const NOTIFICATION_CATEGORIES = {
	signalement: { label: "Signalement", cycle: "traite" },
	stock_modifie: { label: "Stock modifié", cycle: "traite" },
	depanneur_dispo: { label: "Dépanneur disponible", cycle: "auto_expire" },
	location_retard: { label: "Location en retard", cycle: "traite" },
	piquet: { label: "Dispatch de piquet", cycle: "auto_expire" },
	// GE-58 : police à encaissement forcé, « Client parti sans payer ».
	non_encaisse: { label: "Client parti sans payer", cycle: "traite" },
	// GE-69 : véhicule en route vers l'atelier (fiche de réparation).
	vehicule_atelier: { label: "Véhicule pour l'atelier", cycle: "traite" },
}

// GE-69 : lien générique notification → objet métier (`reference_type` /
// `reference_id` posés par emettre_notification). null = pas de page dédiée.
const LIENS_REFERENCE = {
	atelier: (id) => `/atelier/fiche/${id}`,
	location: (id) => `/location/fiche/${id}`,
	inventaire_article: () => "/atelier/inventaire",
}

export const lienNotification = (info) => {
	const lien = info && LIENS_REFERENCE[info.reference_type]
	return lien && info.reference_id ? lien(info.reference_id) : null
}

export const labelCategorie = (cle) =>
	(NOTIFICATION_CATEGORIES[cle] || {}).label || cle || "Notification"

export const estAutoExpire = (cle) =>
	(NOTIFICATION_CATEGORIES[cle] || {}).cycle === "auto_expire"
